import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { SEOService } from '../../../../services/seo.service';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit{
    constructor(private router: Router, private seoService: SEOService, private activatedRoute: ActivatedRoute, private render: Renderer2) { }
    nav(url: any) {
      this.router.navigateByUrl(url)
    }
      ngOnInit(): void {
        this.router.events.pipe(
          filter((event: any) => event instanceof NavigationEnd),
          map(() => this.activatedRoute),
          map((route) => {
            while (route.firstChild) route = route.firstChild;
            return route;
          }),
          filter((route) => route.outlet === 'primary'),
          mergeMap((route: { data: any; }) => route.data)
        )
          .subscribe((event: any) => {
            if (this.router.url === '/company/kalpita-cookie-policy') {
              this.updateDescription(event.description, event.keywords, event.title);
            }
          });
      }
    
      updateDescription(desc: string, keywords: string, title: string) {
        this.seoService.updateDescription(desc);
        this.seoService.updateMetaKeywords(keywords);
        this.seoService.updateTitle(title);
      }
    
}
